import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import UploadComponent from '../UploadComponent';

class ImgUpload extends Component {
    constructor(props){
        super(props);
    }

    render(){
        const {
            classes,
            obj,
            state,
            image,
            successCallback,
            failureCallback,
            bg_opacity
        } = this.props;
        const { values, filename } = state;
        return (
            <div className={classes.uploadComponent}>
                {obj.accept ==
                    'image/png, image/gif, image/jpeg' &&
                    image ? (
                    <img
                        src={image}
                        className={classes.imgPreview}
                        style={
                            (bg_opacity || bg_opacity === 0) && bg_opacity != 100 ?
                            { opacity: bg_opacity / 100.0 } : {}
                        }
                    />
                ) : (
                    ''
                )}
                <UploadComponent
                    accept={obj.accept}
                    type={obj.type}
                    content={
                    values[obj.file]
                        ? filename
                        : obj.upload
                    }
                    bucketName={obj.bucket}
                    uploadToS3={true}
                    uploadObj={{ file: null }}
                    upload_type_name={obj.type}
                    successCallback={(uploadObj, filename) =>
                        successCallback(
                            uploadObj,
                            filename,
                            obj.file,
                        )
                    }
                    failureCallback={failureCallback}
                />
            </div>
        )
    }
}

export default withStyles(useStyles)(ImgUpload);